import React from "react";
import PropTypes from "prop-types";
import Label from "lib/common/controls/Label";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import Control
    from "lib/common/descriptorcontrols/Widget/magicrootsummarysection";
import {
    buildColumn,
    buildCreatable,
    MagicRecordGridDataGateway,
} from "../RecordGridDataGateway";
import SuperRecordStore from "data/SuperRecordStore";
import StereotypesStore from "data/StereotypesStore";
import { ADD_TOP } from "lib/common/descriptorcontrols/BaseControls/RecordGrid/RecordGrid";
import NavigatorStore from "data/NavigatorStore";
import TableStore from "data/TableStore";
import {
    getSuperRecordCreatables,
    getSuperRecordItems,
    getTopLevelRecords,
    TOP_LEVEL_RECORDS_KEY,
} from "data/selectors/superRecords";
import InlineLoader from "views/InlineLoader";

export class Widgetmagicrootsummarysection extends React.Component {
    render() {
        const {
            controlOnly,
            descriptor,
            fluxContext,
            onFocus,
            onBlur,
            onKeyDown,
        } = this.props;
        const magicInfo = NavigatorStore.getMagicState(fluxContext);
        const sp = TableStore.getStereotypeProxy(magicInfo.key, magicInfo.id);
        const childInfo = StereotypesStore.getStereotypeByKey(sp.stereoInfo.magicChildKey);
        const srLO = SuperRecordStore.getRecordLO(sp.stereoKey, sp.id);
        if (!srLO.hasValue()) {
            return <InlineLoader />;
        }
        const srInfo = srLO.getRequiredValue();

        const ar = {
            entityKey: sp.stereoKey,
            id: sp.id,
            topLevelRecords: getSuperRecordItems(getTopLevelRecords(TableStore, srInfo), childInfo)
        };

        const creatables = getSuperRecordCreatables(childInfo)
            .map((it) => buildCreatable(it.implKey, it.name, it.key));

        const columns = [
            buildColumn({
                id: "title",
                content: record =>
                    <Label value={record.getLabel()} />,
                label: "",
                width: ""
            })
        ];

        return (
            <MagicRecordGridDataGateway
                key={descriptor.key}
                component={Control}
                controlOnly={controlOnly}
                activeRecord={ar}
                shortname={TOP_LEVEL_RECORDS_KEY}
                fluxContext={fluxContext}
                descriptor={descriptor}
                addMode={ADD_TOP}
                allowView={true}
                allowCreate={true}
                allowRemove={true}
                columns={columns}
                creatables={creatables}
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
            />
        );
    }
}

Widgetmagicrootsummarysection.propTypes = {
    activeRecord: PropTypes.object,
    descriptor: PropTypes.shape(descriptorPropTypes(null, false)),
    fluxContext: PropTypes.string.isRequired,
    controlOnly: PropTypes.bool,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
};

export default Widgetmagicrootsummarysection;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/Widget/magicrootsummarysection.js